import { AfterViewInit, Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { LoginRequest } from 'src/app/core/auth-result';
import { Store, select } from '@ngrx/store';
import { AppState, CurrentInfoState } from 'src/app/root-store/state';
import { clearLoginPageInfo, hideCustomerChat, login, loginValidation, showCustomerChatDialog } from 'src/app/root-store/actions';
import { Observable, Subject, Subscription } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { selectCurrentWebsiteNameForSeo, selectGoogleTagManagerCode, selectIsSignedIn, selectIsSignInError, selectIsSignInLoading, selectUserDoesNotExist } from 'src/app/root-store/selectors';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, takeUntil, withLatestFrom } from 'rxjs/operators';
import { MetaService } from 'src/app/shared/services/meta.service';
import { DOCUMENT } from '@angular/common';
import { SsrService } from '@hrra/core';
import { FacebookService } from '@hrra/integrations';
import { Patterns } from '@hrra/core';
import { AuthService } from 'src/app/core/auth.service';


//declare var FB: any;

@Component({
    selector: 'app-jobseeker-signin',
    templateUrl: "./redesign/jobseeker-signin.component.html",
    styleUrls: ["./redesign/jobseeker-signin.component.scss"],
    standalone: false
})
export class JobseekerSigninComponent implements OnInit, AfterViewInit {
  
  metaDataSubscription: Subscription;

  private destroy$ = new Subject<void>();

  submitForm: UntypedFormGroup;
  isSignInError$: Observable<boolean>;
  currentInfoState$: Observable<CurrentInfoState>;
  isLoading$: Observable<boolean>;
  returnUrl$: Observable<string>;
  userDoesNotExist$: Observable<boolean>;

  isSignedIn$: Observable<boolean>;

  public readonly signInTab = 0;
  public readonly registrationTab = 1;

  isPasswordVisible = false;

  @Input() isModalOpened = false;
  @Output() success = new EventEmitter<void>();

  onTabChange(value: number | string) {
    if (Number(value) === this.registrationTab) {
      this.router.navigate(['/jobseeker/register']);
    }
  }

  onCheckboxChange() { }

  onLoginClick(returnUrl: string) {
    this.store.dispatch(loginValidation({
      payload: { credentialsInvalid: !this.submitForm.valid }
    }));

    if (this.submitForm.valid) {
      let loginData = <LoginRequest>{
        userName: this.submitForm.get('emailInput').value,
        password: this.submitForm.get('passwordInput').value,
        staySignedIn: this.submitForm.get('staySignedInCheckbox').value,
        returnUrl: returnUrl || 'jobseeker/profile',
        isRedirect: !this.isModalOpened
      };

      this.store.dispatch(login({ payload: loginData }))

    }

  }

  constructor(
    private renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private metaService: MetaService,
    private router: Router, private ssr: SsrService,
    private authService: AuthService
  ) {
  }

  ngAfterViewInit(): void {
    //setTimeout(() => this.store.dispatch(showCustomerChatDialog()), 1000);
  }

  ngOnInit() {

    this.store.dispatch(clearLoginPageInfo());

    this.submitForm = new UntypedFormGroup({
      'emailInput': new UntypedFormControl("", [Validators.required, Validators.pattern(Patterns.emailNew)]),
      'passwordInput': new UntypedFormControl("", [Validators.required]),
      'staySignedInCheckbox': new UntypedFormControl(false)
    });

    this.isLoading$ = this.store.pipe(select(selectIsSignInLoading));
    this.userDoesNotExist$ = this.store.pipe(select(selectUserDoesNotExist));
    this.isSignInError$ = this.store.pipe(select(selectIsSignInError));

    this.store.select(selectIsSignedIn).pipe(takeUntil(this.destroy$)).subscribe((isSignedIn) => {
      if(isSignedIn){
        this.success.emit();
      }
    })

    this.returnUrl$ = this.route.queryParamMap.pipe(map(c=> c.has('returnUrl') ? c.get('returnUrl') : null));

    this.metaDataSubscription = this.store.pipe(select(selectCurrentWebsiteNameForSeo)).subscribe(d => {
      this.metaService.updateMetaData(d);
    });  
  }

  ngOnDestroy() {
    if(this.metaDataSubscription != null){
      this.metaDataSubscription.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete();

    //this.store.dispatch(hideCustomerChat());
  }
}
